import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { useRoleAccess, UserRole } from "./useRoleAccess";

interface RoleBadgeProps {
  role?: UserRole;
  size?: "small" | "medium";
}

export const RoleBadge: React.FC<RoleBadgeProps> = ({
  role,
  size = "small",
}) => {
  const { userRole } = useRoleAccess();
  const displayRole = role || userRole;

  if (!displayRole) return null;

  const getColor = (role: UserRole) => {
    switch (role) {
      case "SUPER_ADMIN":
        return "error";
      case "ADMIN":
        return "primary";
      default:
        return "default";
    }
  };

  const getLabel = (role: UserRole) => {
    switch (role) {
      case "SUPER_ADMIN":
        return "Super Admin";
      case "ADMIN":
        return "Admin";
      default:
        return role;
    }
  };

  return (
    <Chip
      label={getLabel(displayRole)}
      color={getColor(displayRole)}
      size={size}
      variant="outlined"
    />
  );
};
